// core
import React, { useEffect, useState } from "react";
import LModal from "../../../../../common/components/Modals/LModal/LModal";
import ModalHeader from "../../../Modals/ModalHeader/ModalHeader";
import Checkbox from "../../Checkbox/Checkbox";
import styles from "./OccupationClassModal.module.scss";
import Button from "../../Button/Button";
import cx from "classnames";

interface IOccupationClassModal {
    title?: string;
    isOpen: boolean;
    onClose: (occName: string | null, occClass: string | number | null) => void;
}

interface IOccupationOptions {
    title: string;
    class: string;
    description: string;
    enabled: boolean;
}

const occupationOption: IOccupationOptions[] = [
    {
        title: "Occupation Class 1",
        class: "1",
        description:
            "Highly qualified professionals, including desk based professionals and professionals for whom membership in a professional or government body is a requirement for practising e.g. Doctors, Qualified Accountants, Senior Managers etc.",
        enabled: true
    },
    {
        title: "Occupation Class 2",
        class: "2",
        description:
            "Most other desk based professionals, and professionals with no manual labour components to their work.",
        enabled: true
    },
    {
        title: "Occupation Class 3",
        class: "3",
        description:
            'Skilled tradespeople (for example a qualified builder) or "non-desk based" workers (for example technician, shopkeeper, etc).',
        enabled: true
    },
    {
        title: "Occupation Class 4",
        class: "4",
        description:
            "Skilled or semi-skilled manual workers and heavy machinery operators who are not exposed to health hazards.",
        enabled: true
    }
];

const OccupationClassModal: React.FC<IOccupationClassModal> = (props) => {
    const { title, isOpen, onClose } = props;

    const [selectedOption, setSelectedOption] = useState(
        occupationOption.findIndex((c) => title === c.title)
    );

    useEffect(() => {
        if (isOpen) {
            setSelectedOption(occupationOption.findIndex((c) => title === c.title));
        }
    }, [isOpen]);

    return (
        <React.Fragment>
            <LModal
                Header={() => (
                    <ModalHeader onClose={() => onClose(null, null)} title="Occupation" />
                )}
                calcHeightMode="auto"
                width="normal"
                isOpen={isOpen}
                onClose={() => onClose(null, null)}>
                {() => (
                    <React.Fragment>
                        <div className="gap-3xl">
                            <h3
                                className={cx(
                                    "text-primary",
                                    "font-size-l",
                                    "text-no-bold",
                                    "gap-none"
                                )}>
                                Choose the description that best matches your occupation
                            </h3>
                            {occupationOption
                                .filter((i) => i.enabled)
                                .map((occ, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className={styles["occupation-item"]}>
                                            <div className="layout-flex-row--centered">
                                                <Checkbox
                                                    name={occ.title}
                                                    size="l"
                                                    checked={index === selectedOption}
                                                    onChange={(e) => {
                                                        if (e.target.checked)
                                                            setSelectedOption(index);
                                                        else {
                                                            setSelectedOption(null);
                                                        }
                                                    }}
                                                    className="space-m"
                                                />
                                                <p
                                                    className="text-font-size-ml text-zero-margin"
                                                    onClick={() => {
                                                        if (selectedOption === index) {
                                                            setSelectedOption(null);
                                                        } else {
                                                            setSelectedOption(index);
                                                        }
                                                    }}>
                                                    {occ.title}
                                                </p>
                                            </div>
                                            <p
                                                className={cx(
                                                    styles[
                                                        "occupation-item__description"
                                                    ],
                                                    "text-font-size-s",
                                                    "text-line-height-l",
                                                    "text-zero-margin"
                                                )}>
                                                {occ.description}
                                            </p>
                                        </div>
                                    );
                                })}
                        </div>
                        <div className={cx("layout-flex-row--centered", "flex-gap-xl")}>
                            <Button
                                component="button"
                                size="m"
                                variant="calltoaction"
                                onClick={() =>
                                    onClose(
                                        occupationOption[selectedOption]?.title || null,

                                        occupationOption[selectedOption]?.class || null
                                    )
                                }
                                className={cx("layout-flex-s")}>
                                Confirm
                            </Button>

                            <a
                                className={cx(
                                    styles["occupation-cancel"],
                                    "layout-flex-s",
                                    "text-align--center"
                                )}
                                onClick={(e) => {
                                    e.preventDefault();

                                    onClose(null, null);
                                }}>
                                Cancel
                            </a>
                        </div>
                    </React.Fragment>
                )}
            </LModal>
        </React.Fragment>
    );
};

export default OccupationClassModal;
